import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[belenderPageLayoutHeader],belender-page-layout-header'
})
export class PageLayoutHeaderDirective {

  @HostBinding('class') hostClass = 'belender-page-layout-header';

  constructor() { }

}
